import React from 'react'

function StockSummaryReport() {
  return (
    <div>StockSummaryReport</div>
  )
}

export default StockSummaryReport